<div class="notification-center">
    <button
        mat-icon-button
        [matMenuTriggerFor]="notificationMenu"
        [matBadge]="unreadCount"
        [matBadgeHidden]="unreadCount === 0"
        matBadgeColor="warn"
        class="notification-button"
    >
        <mat-icon>notifications</mat-icon>
    </button>

    <mat-menu #notificationMenu="matMenu" class="notification-menu">
        <div class="notification-header">
            <h3>Notifikationer</h3>
            <button mat-button color="primary" (click)="markAllAsRead()" [disabled]="unreadCount === 0">Marker alle som læst</button>
        </div>

        <mat-divider></mat-divider>

        <div class="notification-list">
            <div *ngIf="notifications.length === 0" class="no-notifications">
                <mat-icon>notifications_none</mat-icon>
                <p>Ingen notifikationer</p>
            </div>

            <mat-list *ngIf="notifications.length > 0">
                <mat-list-item
                    *ngFor="let notification of notifications"
                    class="notification-item"
                    [class.unread]="!notification.isRead"
                    (click)="onNotificationClick(notification)"
                >
                    <mat-icon matListItemIcon class="notification-icon">
                        {{ getNotificationIcon(notification.documentType) }}
                    </mat-icon>

                    <div matListItemTitle class="notification-title">
                        {{ notification.title }}
                        <mat-chip *ngIf="!notification.isRead" color="primary" selected class="unread-chip"> Ny </mat-chip>
                    </div>

                    <div matListItemLine class="notification-subtitle">{{ notification.documentType }} fra {{ notification.installationName }}</div>

                    <div matListItemLine class="notification-time">
                        {{ notification.timestamp | date: "short" }}
                    </div>

                    <button mat-icon-button (click)="deleteNotification(notification.id, $event)" class="delete-button">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-list-item>
            </mat-list>
        </div>

        <mat-divider></mat-divider>

        <div class="notification-settings">
            <div class="notification-info">
                <mat-icon>info</mat-icon>
                <p>Notifikationer håndteres automatisk når du besøger siden</p>
            </div>
        </div>
    </mat-menu>
</div>
